/* ICR collection page (Kida Digital, Oct 2026): filters without reloads, load more, SEO show more */
(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (root.dataset.icrReady) return;
    root.dataset.icrReady = '1';
    var sectionId = root.dataset.section;

    // SEO copy: collapse only when it's long enough to need it
    var seo = qs(root, '[data-icr-seo]');
    if (seo && !seo.dataset.ready) {
      seo.dataset.ready = '1';
      var body = qs(seo, '[data-icr-seo-body]');
      var toggle = qs(seo, '[data-icr-seo-toggle]');
      seo.classList.add('is-collapsible');
      if (body.scrollHeight <= body.clientHeight + 40) {
        seo.classList.remove('is-collapsible');
      } else {
        toggle.hidden = false;
        toggle.addEventListener('click', function () {
          var open = seo.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
          toggle.textContent = open ? 'Show less' : 'Show more';
          if (!open) seo.scrollIntoView({ block: 'nearest' });
        });
      }
    }

    // Filter drawer (mobile)
    var scrim = qs(root, '.icr-coll__scrim');
    function openFilters(open) {
      root.classList.toggle('is-filtering', open);
      if (scrim) scrim.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      qsa(root, '[data-icr-filters-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      if (open) { var c = qs(root, '.icr-coll__close'); if (c) c.focus(); }
    }
    qsa(root, '[data-icr-filters-open]').forEach(function (b) { b.addEventListener('click', function () { openFilters(true); }); });
    qsa(root, '[data-icr-filters-close]').forEach(function (b) { b.addEventListener('click', function () { openFilters(false); }); });
    if (!root.dataset.icrKeys) {
      root.dataset.icrKeys = '1';
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-filtering')) { var c = qs(root, '.icr-coll__close'); if (c) c.click(); }
      });
    }

    // "Show all" options in long filter lists
    qsa(root, '[data-icr-f-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var list = b.previousElementSibling;
        var all = list.classList.toggle('is-all');
        b.setAttribute('aria-expanded', String(all));
        if (!b.dataset.label) b.dataset.label = b.textContent;
        b.textContent = all ? 'Show fewer' : b.dataset.label;
      });
    });

    // Filters + sort: update the section in place
    var form = qs(root, '[data-icr-filter-form]');
    var timer;
    function paramsFromForm() {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return p.toString();
    }
    if (form) {
      form.addEventListener('change', function (e) {
        clearTimeout(timer);
        var delay = e.target.type === 'number' ? 500 : 0;
        timer = setTimeout(function () { render(root.dataset.url + '?' + paramsFromForm()); }, delay);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); render(root.dataset.url + '?' + paramsFromForm()); });
    }
    var mirror = qs(root, '[data-icr-sort-mirror]');
    if (mirror && form) {
      mirror.addEventListener('change', function () {
        var sel = form.querySelector('select[name="sort_by"]');
        sel.value = mirror.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    qsa(root, '[data-icr-coll-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        e.preventDefault();
        render(a.href);
      });
    });

    // Load more: append the next page's cards
    var more = qs(root, '[data-icr-load-more]');
    if (more) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        if (more.classList.contains('is-loading')) return;
        more.classList.add('is-loading');
        more.textContent = 'Loading…';
        fetch(withSection(more.href)).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = qs(root, '[data-icr-coll-grid]');
          var newGrid = doc.querySelector('[data-icr-coll-grid]');
          if (grid && newGrid) {
            var first = null;
            Array.prototype.slice.call(newGrid.children).forEach(function (li) {
              var node = document.importNode(li, true);
              grid.appendChild(node);
              if (!first) first = node;
            });
            var link = first && first.querySelector('a[href]');
            if (link) link.focus({ preventScroll: true });
          }
          var nMore = doc.querySelector('[data-icr-load-more]');
          var viewed = doc.querySelector('[data-icr-coll-viewed]');
          var prog = doc.querySelector('[data-icr-coll-progress]');
          var showing = doc.querySelector('.icr-coll__showing');
          if (viewed) qs(root, '[data-icr-coll-viewed]').textContent = viewed.textContent;
          if (prog) qs(root, '[data-icr-coll-progress]').style.width = prog.style.width;
          if (showing) qs(root, '.icr-coll__showing').textContent = showing.textContent;
          var prev = qs(root, '.icr-coll__prev');
          if (prev) prev.remove();
          if (nMore) {
            more.href = nMore.href;
            more.textContent = 'Load more';
            more.classList.remove('is-loading');
          } else {
            more.remove();
          }
        }).catch(function () { window.location.href = more.href; });
      });
    }
  }

  function withSection(url) {
    var root = document.querySelector('[data-icr-coll]');
    var u = new URL(url, window.location.href);
    u.searchParams.set('section_id', root.dataset.section);
    return u.toString();
  }

  function render(url) {
    var root = document.querySelector('[data-icr-coll]');
    if (!root || !window.fetch) { window.location.href = url; return; }
    var wasOpen = root.classList.contains('is-filtering');
    var openGroups = qsa(root, 'details.icr-f').filter(function (d) { return d.open; }).map(function (d) { return d.dataset.icrF; });
    var listsAll = qsa(root, '.icr-f__opts.is-all').map(function (l) { return l.closest('details').dataset.icrF; });
    var formScroll = (root.querySelector('.icr-coll__form') || {}).scrollTop || 0;
    root.classList.add('is-loading');
    fetch(withSection(url)).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-icr-coll]');
      if (!fresh) throw new Error('no section');
      var body = qs(root, '[data-icr-coll-body]');
      var newBody = fresh.querySelector('[data-icr-coll-body]');
      body.parentNode.replaceChild(document.importNode(newBody, true), body);
      var total = qs(root, '[data-icr-coll-total]'), nTotal = fresh.querySelector('[data-icr-coll-total]');
      if (total && nTotal) total.textContent = nTotal.textContent;
      qsa(root, 'details.icr-f').forEach(function (d) {
        if (openGroups.indexOf(d.dataset.icrF) > -1) d.open = true;
        if (listsAll.indexOf(d.dataset.icrF) > -1) {
          var l = d.querySelector('.icr-f__opts'), b = d.querySelector('[data-icr-f-more]');
          if (l && b) { l.classList.add('is-all'); b.dataset.label = b.textContent; b.textContent = 'Show fewer'; b.setAttribute('aria-expanded', 'true'); }
        }
      });
      var clean = new URL(url, window.location.href);
      clean.searchParams.delete('section_id');
      clean.searchParams.delete('page');
      window.history.replaceState({}, '', clean.pathname + clean.search);
      root.classList.remove('is-loading');
      delete root.dataset.icrReady;
      init(root);
      if (wasOpen) {
        root.classList.add('is-filtering');
        var scrim = qs(root, '.icr-coll__scrim');
        if (scrim) scrim.hidden = false;
        var f = root.querySelector('.icr-coll__form');
        if (f) f.scrollTop = formScroll;
      } else {
        var res = qs(root, '[data-icr-coll-results]');
        if (res && res.getBoundingClientRect().top < 0) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }).catch(function () { window.location.href = url; });
  }

  function boot() { document.querySelectorAll('[data-icr-coll]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();